import type { ShellLayoutContextValue } from "@circle-react-uikit/CircleAIAppShell/Layout/context";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useShallow } from "zustand/react/shallow";

/**
 * Adapter that maps the CircleAI shell store onto the controlled
 * `CircleAIAppShell.Layout` props. This is the single place layout state is
 * read from the store; the Layout primitives themselves are store-agnostic.
 */
export const useCircleAIShellLayoutState = (): ShellLayoutContextValue =>
  useCircleAIShellStore(
    useShallow(s => ({
      dockMode: s.dockMode,
      conversationPanelState: s.conversationPanelState,
      conversationPanelWidth: s.conversationPanelWidth,
      isLeftSidebarVisible: s.isLeftSidebarVisible,
      leftSidebarWidth: s.leftSidebarWidth,
      isRightSidebarVisible: s.isRightSidebarVisible,
      rightSidebarWidth: s.rightSidebarWidth,
      onConversationPanelWidthChange: s.setConversationPanelWidth,
    })),
  );
